module.exports = __webpack_public_path__ + "avatar-placeholder.0876f92fb5eea75f41a4872a88b45c39.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Avatar/img/avatar-placeholder.svg
// module id = 1220
// module chunks = 8